module.exports = __webpack_public_path__ + "img/ic_home_logo.b2bc1fec.png";